module.exports = __webpack_public_path__ + "img/conversions-low.4e74df3f.svg";